import { createSlice } from '@reduxjs/toolkit'
import {
  AUTO,
  BICYCLE,
  FREIGHT,
  PEDESTRIAN,
  TRANSIT
} from '../../constants/modalTiers'

const initialState = {
  Priority_1: '',
  Priority_2: '',
  Priority_3: '',
  Priority_4: '',
  Priority_5: ''
  // selectedPriorities: [],
  // availablePriorities: [PEDESTRIAN, BICYCLE, TRANSIT, AUTO, FREIGHT]
}

const modalPrioritization = createSlice({
  name: 'modalPrioritization',
  initialState,
  reducers: {
    setModalPrioritization(state, action) {
      const { field, value } = action.payload
      state[field] = value
    },
    resetModalPrioritization(state) {
      return initialState
    },
    setAllModalPrioritization(state, action) {
      return action.payload
    },
    setSelectedPriorities(state, action) {
      if (!state.selectedPriorities.includes(action.payload)) {
        state.selectedPriorities = [...state.selectedPriorities, action.payload]
      }

      state.availablePriorities = state.availablePriorities.filter(
        (priority) => priority !== action.payload
      )
    },
    addAvailablePriorities(state, action) {
      state.availablePriorities = [...state.availablePriorities, action.payload]
    }
  }
})

export const {
  setModalPrioritization,
  resetModalPrioritization,
  setAllModalPrioritization,
  setSelectedPriorities,
  addAvailablePriorities
} = modalPrioritization.actions
export default modalPrioritization.reducer
